import React from "react";
import ProducerDetail from "../../components/global/Producers/ProducerDetail";
import BaseWineSearchBar from "../../components/global/SearchBar/BaseWineSearchBar";
import Header from "../../components/layout/Header/Header";
import Layout from "../../components/layout/Layout/Layout";
import { baseWineSearch, getProducer, getWines } from "../../lib/wineRequests";
import { getArticle } from "../../lib/articleRequests";
import { withUserSSR } from "../../utils/withUserSSR";

export default function ProducersPage({
  slug,
  articleId,
  producer,
  article,
  initialWines,
  initialDisplayType,
  error,
}: any) {
  return (
    <Layout>
      <Header />
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <ProducerDetail
        slug={slug}
        articleId={articleId}
        producer={producer}
        article={article}
        initialWines={initialWines}
        initialDisplayType={initialDisplayType}
        error={error}
      />
    </Layout>
  );
}

export const getServerSideProps = withUserSSR(async (context: any) => {
  const { params } = context;
  const { query } = context;
  // Forward the visitor's session so subscribers get full tasting notes.
  const cookie = context.req.headers.cookie || "";
  const slug = params.slug || [];
  const displayType = "wine"
  let articleId =
    query.article_id && query.article_id.length > 0 ? query.article_id : null;
  let articleData = null;

  try {
    const { data: producerData } = await getProducer(slug?.[0] as string, cookie);
    
    try {
      if (articleId) {
        articleData = await getArticle(query.article_id as string);
      }
    } catch(error) {
      console.error("Error fetching article data:", error);
      articleId = null; // Reset articleId if fetching fails
    }

    const requestParams = {
      sort: "vintage",
      order_type: query.sortDirection ? "asc" : "desc",
      page: query.page || 1,
      perPage: query.per_page || 25,
      displayType: displayType,
      ["filters[producer_id]"]: producerData.producer.id,
      ...(articleId && { ["filters[article_id]"]: parseInt(articleId) }),
      term: "",
      
    };


    const { data } =
      displayType === "wine"
        ? await getWines(requestParams, cookie)
        : await baseWineSearch(requestParams, cookie);

    return {
      props: {
        slug,
        articleId,
        article: articleData ? articleData.data : null,
        producer: producerData.producer,
        initialWines: data,
        initialDisplayType: displayType,
      },
    };
  } catch (error) {
    console.error(
      "Error fetching producer data:",
      error.data?.error || error?.message,
      error
    );

    if (error.data?.status === 404) {
      return {
        notFound: true,
      };
    }
    // Handle other errors gracefully
    return {
      props: {
        error: error.data?.error || error.message || "An error occurred loading producer data.",
      },
    };
  }
});
